import { ImageElement as ImageElementType } from '@/types'

interface ImageElementProps {
  element: ImageElementType
  zoom: number
  mmToPx: number
}

export function ImageElementComponent({ element, zoom, mmToPx }: ImageElementProps) {
  const width = element.width * mmToPx * zoom
  const height = element.height * mmToPx * zoom

  return (
    <img
      src={element.imageData}
      alt={element.name}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        objectFit: 'contain',
        imageRendering: 'pixelated'
      }}
      draggable={false}
    />
  )
}
